import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GuardDetailsModalComponent } from '../guard-details-modal/guard-details-modal.component';
import { CurrencyFormatPipe } from '../../pipes/currency-format.pipe';
import { getSelectedShift } from 'src/app/components/assignments/store/assignment.selector';
import { Store } from '@ngrx/store';
import * as fromApp from "../../../store/app.reducer"

@Component({
  selector: 'app-assigment-shift-summary-calculation',
  imports: [TranslateModule, CommonModule, CurrencyFormatPipe],
  templateUrl: './assigment-shift-summary-calculation.component.html',
  styleUrl: './assigment-shift-summary-calculation.component.scss',
  standalone: true,
  providers: [CurrencyPipe, DatePipe]
})
export class AssigmentShiftSummaryCalculationComponent implements OnInit, OnChanges {
  //Variable declaration
  @Input() costPerGuard: number;
  @Input() duration: number;
  @Input() guardCount: number;
  @Input() totalCost: number;
  assignmentCreateData: boolean = false;
  summaryData: any
  shiftData$: any
  //Lifecycle hooks
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<fromApp.AppState>,
    private dialogRef: MatDialogRef<GuardDetailsModalComponent>,
    private cdr: ChangeDetectorRef
  ) {
    this.assignmentCreateData = data?.isCreateAssignment ?? false;
    this.summaryData = data.summaryData
  }

  ngOnInit(): void {
    this.shiftData$ = this.store.select(getSelectedShift);

    this.shiftData$.subscribe(shiftData => {
      if (shiftData) {
        // Update component @Input() / local variables for template binding
        this.duration = shiftData.duration ?? this.duration;
        this.costPerGuard = shiftData.costPerGuard ?? this.costPerGuard;
        this.guardCount = shiftData.guardCount ?? this.guardCount;

        // Calculate totalCost from hourly rate, duration, and guard count
        this.calculateTotalCost();

        // Trigger change detection
        this.cdr.markForCheck();
      }
    });

    // Also calculate if we have inputs directly (not from store)
    this.calculateTotalCost();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Recalculate totalCost when inputs change
    if (changes['costPerGuard'] || changes['duration'] || changes['guardCount']) {
      this.calculateTotalCost();
    }
  }

  private calculateTotalCost(): void {
    if (this.costPerGuard && this.duration && this.guardCount) {
      const hourlyRate = this.CalculationGuardPerHoursRate(this.costPerGuard, this.duration);
      // Calculate totalCost: hourlyRate * duration * guardCount
      this.totalCost = parseFloat((hourlyRate * this.duration * this.guardCount).toFixed(2));
    }
  }

  // Other Functions
  CalculationGuardPerHoursRate(costPerGuard: number, duration: number): number {
    if (!costPerGuard || !duration || duration <= 0) {
      return 0;
    }
    const rate = costPerGuard / duration;
    return parseFloat(rate.toFixed(2));
  }

  get newTotalCost(): number {
    const hourlyRate = this.CalculationGuardPerHoursRate(this.costPerGuard, this.duration);
    return hourlyRate * this.duration * this.guardCount;
  }

  // Calculate total cost from hourly rate, duration, and guard count
  get calculatedTotalCost(): number {
    if (!this.costPerGuard || !this.duration || !this.guardCount) {
      return this.totalCost ?? 0;
    }
    const hourlyRate = this.CalculationGuardPerHoursRate(this.costPerGuard, this.duration);
    const calculated = hourlyRate * this.duration * this.guardCount;
    return parseFloat(calculated.toFixed(2));
  }

  //Vat amount 25 percentage
  get vatAmount(): number {
    return (this.totalCost ?? 0) * 0.25;
  }

  calculationSubSection(totalCost: number): number {
    // Your existing logic
    const cost = totalCost || this.totalCost || 0;
    return cost + this.vatAmount;
  }

  getRatePerHour(dateWithPrice: any): number {
    if (!dateWithPrice?.duration || !dateWithPrice?.customerPerShiftPerGuard) {
      return 0;
    }
    const ratePerHour = dateWithPrice.customerPerShiftPerGuard;
    return parseFloat(ratePerHour.toFixed(2));
  }

  getShiftDurationHours(startAt: string, endAt: string): number {
    const start = new Date(startAt);
    const end = new Date(endAt);
    const diffInHours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
    return Math.round(diffInHours * 100) / 100; // round to 2 decimals
  }

  closeModal() {
    this.dialogRef.close();
  }
}
